/** Base explore filter trigger — matches date range Select styling. */
export const FILTER_TRIGGER_BASE =
  "h-8 rounded-lg border border-border bg-background px-3 text-xs font-medium text-foreground transition-colors hover:bg-muted/50";

export const FILTER_TRIGGER_LABEL = "shrink-0 text-muted-foreground font-normal";

export const FILTER_TRIGGER_VALUE = "shrink-0 text-foreground font-medium";

/** Validation — border + text only; neutral background (no red/amber fills). */
export const FILTER_TRIGGER_INVALID =
  "border-destructive text-destructive hover:bg-background";
